import { IAppStore } from './store';

import { directionsModalOpenSaga } from '../../filters/state/directions';
import { districtSwitcherOpenSaga } from '../../filters/state/districts/popup';
import {
  locationSwitcherAutocompleteSaga,
  locationSwitcherCitySelectionSaga,
  locationSwitcherOpenSaga,
  locationSwitcherRegionSelectionSaga,
} from '../../filters/state/location_switcher';
import { metaSaga } from '../../filters/state/meta';
import { searchSaga } from '../../filters/state/search';
import { newbuildingSearchSaga } from '../../filters/state/ab/newbuildingSearch';
import { subscribeSaga } from '../../filters/state/subscribings/serp_subscribe';
import { agentRatingSaga } from '../../serp/state/offer_card/agent';
import { offerCommentsSaga } from '../../serp/state/offer_card/comments';
import { suggestionsDistacesSaga } from '../../serp/state/suggestions';
import { hideOfferSaga } from '../../serp/state/hide_offer';
import { demandSagas } from '../../sagas/demand';
import { verifyPhoneSagas } from '../../sagas/verifyPhone';
import { commercialSurveyWidgetModalSaga } from '../../serp/state/commecial_survey';
import { coworkingExperimentsRootSaga } from '../../serp/state/coworking_experiments';

export function attachSagas(store: IAppStore) {
  store.runSaga(metaSaga);
  store.runSaga(locationSwitcherOpenSaga);
  store.runSaga(locationSwitcherRegionSelectionSaga);
  store.runSaga(locationSwitcherCitySelectionSaga);
  store.runSaga(locationSwitcherAutocompleteSaga);
  store.runSaga(districtSwitcherOpenSaga);
  store.runSaga(directionsModalOpenSaga);
  store.runSaga(searchSaga);
  store.runSaga(offerCommentsSaga);
  store.runSaga(subscribeSaga);
  store.runSaga(suggestionsDistacesSaga);
  store.runSaga(agentRatingSaga);
  store.runSaga(hideOfferSaga);
  store.runSaga(demandSagas);
  store.runSaga(verifyPhoneSagas);
  // Эксперимент PM-4585
  store.runSaga(newbuildingSearchSaga);
  store.runSaga(commercialSurveyWidgetModalSaga);
  store.runSaga(coworkingExperimentsRootSaga);
}
